import { Table } from './table';
import ShellAPI from 'a365-shell-api';
import { validateName } from '../../shared/utils/validation.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

export class TableUtils {
    public static getDataType(table: Table, columnName: string): string | undefined {
        const columns = table.content.storageDescriptor.columns;
        for (const column of columns) {
            if (column.name === columnName) {
                return column.originDataTypeName.typeName;
            }
        }

        return undefined;
    }

    public static async validateName(tableName: string, databaseName: string): Promise<string[] | undefined> {
        const patternViolations = validateName(tableName, shellStringResources.Table);
        if (patternViolations.length) {
            return patternViolations;
        }
        const duplicatedTables = (await ShellAPI.artifacts.listArtifacts<Table>('table'))
                            .filter((artifact) => artifact.parentInfo.resourceName === databaseName && artifact.realName === tableName);
        if (duplicatedTables.length) {
            return [shellStringResources.Validator_Table_NameNotUnique];
        }
        return undefined;
    }
}
